"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TypeFormScrollableForm = exports.Blades = void 0;
var classnames_1 = require("classnames");
var React = require("react");
var react_1 = require("react");
var _1 = require(".");
var BladeFlowService_1 = require("../../services/BladeFlowService");
var scroll_1 = require("../../utils/scroll");
var Blades = function (props) {
    var backToTopLabel = props.backToTopLabel, bladesClassName = props.bladesClassName, blades = props.blades, content = props.content, _a = props.displayBackToTop, displayBackToTop = _a === void 0 ? true : _a, _b = props.formValue, formValue = _b === void 0 ? {} : _b, goBackPreviousBlade = props.goBackPreviousBlade, initFormValue = props.initFormValue, onComplete = props.onComplete, onValueChange = props.onValueChange, useFormValueState = props.useFormValueState;
    // IMP: pass the full formValue to the blade when needed.
    // => Each blade needs to update shouldComponentUpdate as formValue object is changing every time.
    var elements = blades.map(function (blade, index) {
        var _a = blade.name, name = _a === void 0 ? '' : _a;
        var previousBladeDisplayName = blades[index - 1] && blades[index - 1].displayName;
        var bladeFormValue = formValue[name];
        var goBackButtonContent = content && content.Shared ? content : null;
        return (React.createElement("div", { className: (0, classnames_1.default)("hc-bladeview", {
                bladesClassName: bladesClassName,
            }), key: name },
            React.createElement("div", { className: (0, classnames_1.default)('hc-blade', {
                    'hc-blade--scrolling': index !== 0,
                }) },
                React.createElement("div", { className: "gutter-px" },
                    React.createElement("div", { className: "row " + name, id: name },
                        React.createElement("div", { className: "col-12" },
                            displayBackToTop && (React.createElement(_1.BladeGoBackButton, { content: goBackButtonContent, backToTopLabel: backToTopLabel, 
                                // tslint:disable-next-line jsx-no-lambda
                                onClick: function () {
                                    goBackPreviousBlade(name);
                                }, targetBladeName: previousBladeDisplayName })),
                            React.createElement(blade.component, {
                                bladeName: name,
                                className: bladesClassName,
                                content: blade.content,
                                formValue: formValue,
                                goBackPreviousBlade: goBackPreviousBlade,
                                index: index,
                                initFormValue: initFormValue,
                                onComplete: onComplete,
                                onValueChange: onValueChange,
                                previousBladeDisplayName: previousBladeDisplayName,
                                selectedValue: bladeFormValue,
                                useFormValueState: useFormValueState,
                            })))))));
    });
    return (React.createElement(React.Fragment, null, elements));
};
exports.Blades = Blades;
var TypeFormScrollableForm = /** @class */ (function (_super) {
    __extends(TypeFormScrollableForm, _super);
    function TypeFormScrollableForm(props) {
        var _this = _super.call(this, props) || this;
        /**
         * onValueChange
         * @description this is a callback function passdown to each blade.
         * It trigger whenever a form value change. If user scroll back up to previous blade,
         * it will check by current blade index and remove the following blades.
         */
        _this.onValueChange = function (bladeName, index) {
            var blades = _this.state.blades;
            var currentBladesLength = blades.length;
            var newState = {};
            if (index < currentBladesLength - 1) {
                // remove following blades from current blade index
                blades.length = index + 1;
                newState.blades = blades;
                // rebuild formValue state to match new blades
                var newFormValue_1 = {};
                blades.forEach(function (blade) {
                    var thisBladeName = blade.name;
                    newFormValue_1[thisBladeName] = _this.state.formValue[thisBladeName];
                });
                newState.formValue = newFormValue_1;
            }
            // only re-render when we need to update blades
            if (newState.blades) {
                // @ts-ignore: TODO - newState and state need Typescript merge object type...
                _this.setState(function () { return (__assign({}, newState)); });
            }
        };
        /**
         * onComplete
         * @description this callback passdown to each blade
         * it trigger when a blade click 'next'. It will store the current blade form value
         * in state.formValue[bladeName] and then add the next blade to be re-render
         */
        _this.onComplete = function (bladeName, index, value, prevValue) {
            var _a;
            // completeSpecialCase mean the final blade form submission.
            // There is no more next blade to be workout
            if (_this.completeSpecialCase(bladeName)) {
                return;
            }
            // Update form values
            var newValue = __assign(__assign({}, _this.state.formValue), (_a = {}, _a[bladeName] = value, _a));
            // Get next blade based on the new form value
            var nextBlade = _this.props.flowService.getNextBlade(bladeName, newValue);
            // Add blade
            // IMP: Maybe it's better to change blades to a new array everytime.
            // => If we are using redux, this will be done by a reducer.
            var blades = _this.state.blades;
            if (index + 1 >= blades.length) {
                _this.state.blades.push(nextBlade);
            }
            else {
                // If index is less than current blades length, it depends on whether the blade has implemented onValueChange,
                // reset the flow here, or insert / delete blades behind it. This should be very fast.
                _this.setState(function (state) { return (__assign(__assign({}, state), { blades: __spreadArray(__spreadArray([], (state.blades.slice(0, index + 1)), true), [nextBlade], false) })); });
            }
            // only setState if value chagned
            if (value !== prevValue) {
                _this.setState({ formValue: newValue }, function () {
                    _this.scrollNextBladeThenFocus(nextBlade);
                });
            }
            else {
                _this.scrollNextBladeThenFocus(nextBlade);
            }
        };
        _this.goBackPreviousBlade = function (bladeName) {
            // Update form values
            var newValue = __assign({}, _this.state.formValue);
            // Get next blade based on the new form value
            var previousBlade = _this.props.flowService.getPreviousBlade(bladeName, newValue);
            _this.scrollToPreviousBladeThenFocus(previousBlade);
        };
        // eslint-disable-next-line consistent-return
        _this.completeSpecialCase = function (bladeName) {
            if (bladeName === 'confirmation') {
                if (_this.props.onConfirmed) {
                    _this.props.onConfirmed(_this.state.formValue);
                }
                return true;
            }
        };
        _this.scrollToPreviousBladeThenFocus = function (blade) {
            var firstBlade = _this.state.blades[0];
            // first blade does not contain margins.
            var scrollBuffer = _this.scrollToBladeBuffer;
            var scrollToOffset = blade.name === (firstBlade === null || firstBlade === void 0 ? void 0 : firstBlade.name) ? 0 : _this.ScrollContainerOffset;
            (0, scroll_1.scrollPreviousBladeAndFocus)(blade.name, scrollBuffer, scrollToOffset);
        };
        _this.scrollNextBladeThenFocus = function (blade) {
            (0, scroll_1.scrollNextBladeAndFocus)(blade.name, _this.scrollToBladeBuffer, _this.ScrollContainerOffset);
        };
        _this.useFormValueState = function () {
            // function that passdown to child in order to read / update the formValue state
            // formValue state is the selected form values
            var setFormValueState = function (newFormValue) {
                if (newFormValue === void 0) { newFormValue = {}; }
                _this.setState(function (state) {
                    var newFormValueState = __assign(__assign({}, state.formValue), newFormValue);
                    return { formValue: newFormValueState };
                });
            };
            return [_this.state.formValue, setFormValueState];
        };
        var flowService = _this.props.flowService;
        var initBlade = flowService.getInitialBlade();
        var initFormValue = flowService.getInitialFormValueState();
        _this.state = {
            blades: [initBlade],
            formValue: initFormValue,
        };
        _this.initFormValue = initFormValue;
        _this.useFormValueState = _this.useFormValueState.bind(_this);
        _this.scrollNextBladeThenFocus = _this.scrollNextBladeThenFocus.bind(_this);
        _this.scrollToPreviousBladeThenFocus = _this.scrollToPreviousBladeThenFocus.bind(_this);
        _this.scrollToBladeBuffer = 0;
        _this.ScrollContainerOffset = 48; // spacer set on the container of the document of 6x
        return _this;
    }
    TypeFormScrollableForm.prototype.componentDidMount = function () {
        var bladeViewHeightConfig = this.props.bladeViewHeightConfig;
        var headerCss = '.headerorigination';
        // workout headerorigination size
        var headerNode = document.querySelector(headerCss);
        if (headerNode) {
            this.scrollToBladeBuffer = headerNode.getBoundingClientRect().height;
        }
        // set bladeview min heigh with provided config
        if (bladeViewHeightConfig) {
            (0, BladeFlowService_1.setBladeViewMinHeight)(bladeViewHeightConfig);
        }
    };
    TypeFormScrollableForm.prototype.render = function () {
        var _a = this.props, backToTopLabel = _a.backToTopLabel, _b = _a.bladesClassName, bladesClassName = _b === void 0 ? '' : _b, content = _a.content, _c = _a.className, className = _c === void 0 ? '' : _c, displayBackToTop = _a.displayBackToTop;
        var classNames = ("hc-blade-flow " + className).trim();
        return (React.createElement("form", { className: classNames, noValidate: true },
            React.createElement(exports.Blades, { backToTopLabel: backToTopLabel, blades: this.state.blades, bladesClassName: bladesClassName, content: content, displayBackToTop: !!displayBackToTop, formValue: this.state.formValue, goBackPreviousBlade: this.goBackPreviousBlade, initFormValue: this.initFormValue, onComplete: this.onComplete, onValueChange: this.onValueChange, useFormValueState: this.useFormValueState })));
    };
    TypeFormScrollableForm.defaultProps = {
        bladesClassName: '',
        className: '',
        content: {},
        displayBackToTop: true,
        flowService: {},
    };
    return TypeFormScrollableForm;
}(react_1.Component));
exports.TypeFormScrollableForm = TypeFormScrollableForm;
